import React from "react";
import { View } from "react-native";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";
import { uniqueId } from "lodash";

export default function WandIcon(props) {
  const color = props.color || "#FFF";
  const filterId = "clip0" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  return (
    <View style={props.style} {...props}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath={filterUrl}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.105 2.82564C12.5172 2.82564 12.8514 2.4915 12.8514 2.07932C12.8514 1.66715 12.5172 1.33301 12.105 1.33301C11.6929 1.33301 11.3587 1.66715 11.3587 2.07932C11.3587 2.4915 11.6929 2.82564 12.105 2.82564ZM16.5454 6.09968C16.9803 6.09968 17.333 5.74036 17.333 5.29711C17.333 4.85386 16.9803 4.49454 16.5454 4.49454C16.1104 4.49454 15.7578 4.85386 15.7578 5.29711C15.7578 5.74036 16.1104 6.09968 16.5454 6.09968ZM9.64107 6.49722C9.64107 6.9094 9.30693 7.24354 8.89475 7.24354C8.48257 7.24354 8.14844 6.9094 8.14844 6.49722C8.14844 6.08504 8.48257 5.75091 8.89475 5.75091C9.30693 5.75091 9.64107 6.08504 9.64107 6.49722ZM13.4179 10.5588C13.83 10.5588 14.1642 10.2247 14.1642 9.81251C14.1642 9.40033 13.83 9.06619 13.4179 9.06619C13.0057 9.06619 12.6715 9.40033 12.6715 9.81251C12.6715 10.2247 13.0057 10.5588 13.4179 10.5588ZM15.8103 2.85565C15.8103 3.26783 15.4762 3.60197 15.064 3.60197C14.6518 3.60197 14.3177 3.26783 14.3177 2.85565C14.3177 2.44347 14.6518 2.10933 15.064 2.10933C15.4762 2.10933 15.8103 2.44347 15.8103 2.85565ZM9.57346 4.33702C9.98564 4.33702 10.3198 4.00289 10.3198 3.59071C10.3198 3.17853 9.98564 2.84439 9.57346 2.84439C9.16129 2.84439 8.82715 3.17853 8.82715 3.59071C8.82715 4.00289 9.16129 4.33702 9.57346 4.33702ZM16.7404 8.16237C16.7404 8.57455 16.4062 8.90869 15.994 8.90869C15.5819 8.90869 15.2477 8.57455 15.2477 8.16237C15.2477 7.75019 15.5819 7.41606 15.994 7.41606C16.4062 7.41606 16.7404 7.75019 16.7404 8.16237ZM12.6113 7.3748H12.7613C13.1029 7.36742 13.4291 7.23118 13.6744 6.9934C13.9197 6.75562 14.0661 6.43387 14.0841 6.0927C14.1021 5.75152 13.9905 5.41614 13.7716 5.15382C13.5527 4.8915 13.2427 4.72164 12.9038 4.67831C12.8552 4.67457 12.8063 4.67457 12.7576 4.67831C12.4158 4.68487 12.0891 4.82051 11.8431 5.05799C11.5972 5.29548 11.4502 5.61721 11.4317 5.9586C11.4132 6.29998 11.5245 6.63573 11.7433 6.89843C11.9621 7.16112 12.2722 7.3313 12.6113 7.3748ZM11.5061 7.56676C11.8016 7.80834 12.1607 7.95919 12.5401 8.0011L12.6564 8.0086L5.3057 18.0295C5.24076 18.1182 5.15895 18.1933 5.06497 18.2504C4.97098 18.3075 4.86666 18.3454 4.75798 18.3622C4.6493 18.3789 4.53838 18.374 4.43159 18.3478C4.32479 18.3216 4.22421 18.2746 4.13559 18.2095L3.6743 17.872C3.49806 17.7404 3.38047 17.5448 3.34681 17.3275C3.31315 17.1101 3.3661 16.8881 3.49429 16.7094L10.8749 6.63973C10.9914 7.0032 11.2106 7.32517 11.5061 7.56676Z"
            fill={color}
          />
        </G>
        <Defs>
          <ClipPath id={filterId}>
            <Rect
              width="14"
              height="17.0378"
              fill={color}
              transform="translate(3.33325 1.33301)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
}
